import { TabletSectionStyles } from '../../styles/styles';

type Prop = {
  tabletImgSrc: string[];
};

const TabletSection = (props: Prop) => {
  const { tabletImgSrc } = props;
  const mobile = window.innerWidth < 500 ? true : false;
  return (
    <TabletSectionStyles data-scroll-section>
      <div data-scroll data-scroll-speed={mobile ? '1' : '4'} className="side">
        <img src={tabletImgSrc[1]} alt="" />
      </div>
      <div
        data-scroll
        data-scroll-speed={mobile ? '1' : '0.5'}
        className="main">
        <img src={tabletImgSrc[0]} alt="" />
      </div>
    </TabletSectionStyles>
  );
};

export default TabletSection;
